import { apiClient } from '@/services/api';
import type { GetAvatarsResponse, SelectAvatarResponse } from '@/types';

export async function selectAvatar(
  gameId: string,
  avatarId: string,
  _accessToken: string
): Promise<SelectAvatarResponse> {
  const response = await apiClient.selectAvatar(gameId, avatarId);
  return response as SelectAvatarResponse;
}

export async function getAvatars(
  gameId: string,
  _accessToken: string
): Promise<GetAvatarsResponse> {
  const gameState = await apiClient.getGameState(gameId);
  return {
    avatars: gameState.avatars || [],
    gameId,
    phase: gameState.phase,
  };
}
